// from general.js
/* global showVideoLightBox jQuery */
import { formatCurrencyV2 } from '../common/formatCurrency.ts';

/**
 * Pulled from C5.common.js since this is the only place we use FormatNumber (AFAICT)
 * At some point we could replace it with a centralized format number function we
 * want to use across the codebase.
 */
function FormatNumber(num, abbreviate, decPoints) {
    let result = '';
    if (abbreviate == null) { abbreviate = false; }
    if (isNaN(num)) { num = '0'; }
    if (parseInt(num) > 999) {
        const sign = (num == (num = Math.abs(num)));
        num = Math.floor(num * 100 + 0.50000000001);
        num = Math.floor(num / 100).toString();
        for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
            num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
        }
        if (abbreviate) {
            if (num.length < 9) {
                if (num.indexOf(',') != -1) {
                    num = num.substring(0, num.lastIndexOf(',') + decPoints) + 'k'; num = num.replace(',', '.');
                }
            } else {
                if (num.indexOf(',') != -1) {
                    num = num.substring(0, num.lastIndexOf(','));
                    num = num.substring(0, num.lastIndexOf(',') + decPoints) + 'M';
                    num = num.replace(',', '.');
                }
            }
        }
        result = ((sign) ? '' : '-') + num; return result;
    } else {
        return num;
    }
}

$(function () {
    $('.js-play-button').click(function (e) {
        showVideoLightBox(this.href);
        e.preventDefault();
    });
    $.getJSON(baseCacheURL + 'about/impact.json', function (data) {
        $('#js-percentage-schools').html(jQuery.parseJSON(data.stats.publicSchools) + '% of public schools');
        $('#js-supporters').html(FormatNumber(jQuery.parseJSON(data.stats.supporters), false) + ' citizen donors');
        $('#js-schools-participating').html(FormatNumber(jQuery.parseJSON(data.stats.schoolsParticipating), false) + ' schools');
        $('#js-dollars-raised').html(formatCurrencyV2(jQuery.parseJSON(data.stats.dollarsRaised), 'HIDE_CENTS'));
    });

    if ($('.js-navigation').length > 0) {
        const stick = $('.js-navigation');
        const pos = stick.offset();
        $(window).scroll(function () {
            if ($(window).scrollTop() > pos.top && stick.css('position') === 'static') {
                stick.addClass('sticky');
            } else if ($(window).scrollTop() <= pos.top && stick.hasClass('sticky')) {
                stick.removeClass('sticky');
            }
        });
    }

    const animateStats = function () {
        const $one = $('.js-animate-one');
        const $two = $('.js-animate-two');
        const $three = $('.js-animate-three');
        const $four = $('.js-animate-four');
        const hT1 = $one.offset().top;
        const hH1 = $one.outerHeight();
        const hT2 = $two.offset().top;
        const hH2 = $two.outerHeight();
        const hT3 = $three.offset().top;
        const hH3 = $three.outerHeight();
        const hT4 = $four.offset().top;
        const hH4 = $four.outerHeight();
        const wH = $(window).height();
        const scroll = $(window).scrollTop();

        if (scroll > (hT1 + hH1 - wH)) {
            if (!$one.hasClass('fadeInUp')) {
                $one.addClass('fadeInUp');
            }
        }
        if (scroll > (hT2 + hH2 / 2 - wH)) {
            if (!$two.hasClass('fadeInUp')) {
                $two.addClass('fadeInUp');
            }
        }
        if (scroll > (hT3 + hH3 / 2 - wH)) {
            if (!$three.hasClass('fadeInUp')) {
                $three.addClass('fadeInUp');
            }
        }
        if (scroll > (hT4 + hH4 / 2 - wH)) {
            if (!$four.hasClass('fadeInUp')) {
                $four.addClass('fadeInUp');
            }
        }
    };

    animateStats();

    $(window).scroll(function () {
        animateStats();
    });
});
